import React, { useState } from 'react';
import { useNavigate, useSearchParams } from 'react-router-dom';
import { api } from '../services/api';
import { Input, Btn, Alert, C } from '../components/UI';
import { useBranding } from '../context/BrandingContext';

export default function ResetPasswordPage() {
  const navigate = useNavigate();
  const branding = useBranding();
  const [params] = useSearchParams();
  const token = params.get('token') ?? '';
  const email = params.get('email') ?? '';

  const [newPassword, setNewPassword] = useState('');
  const [confirm, setConfirm] = useState('');
  const [error, setError] = useState('');
  const [done, setDone] = useState(false);
  const [loading, setLoading] = useState(false);

  const handleSubmit = async (e: React.FormEvent) => {
    e.preventDefault();
    if (newPassword !== confirm) { setError('Passwords do not match.'); return; }
    if (newPassword.length < 8) { setError('Password must be at least 8 characters.'); return; }
    setError(''); setLoading(true);
    try {
      await api.resetPassword(token, email, newPassword);
      setDone(true);
    } catch (err: any) { setError(err.message); }
    finally { setLoading(false); }
  };

  const navText = branding.navTextColor ?? '#ffffff';
  return (
    <div style={{ minHeight: '100vh', background: `linear-gradient(135deg, ${branding.secondaryColor} 0%, ${branding.primaryColor} 100%)`, display: 'flex', alignItems: 'center', justifyContent: 'center', padding: 24 }}>
      <div style={{ background: '#fff', borderRadius: 16, padding: 36, width: '100%', maxWidth: 420, boxShadow: '0 20px 60px rgba(0,0,0,0.15)' }}>
        <div style={{ textAlign: 'center', marginBottom: 28 }}>
          {branding.logoUrl
            ? <img src={branding.logoUrl} alt={branding.appName} style={{ height: 48, maxWidth: 200, objectFit: 'contain' }} />
            : <div style={{ fontSize: 28, fontWeight: 800, color: branding.primaryColor, letterSpacing: -1 }}>{branding.appName}</div>
          }
        </div>

        {done ? (
          <div style={{ textAlign: 'center' }}>
            <div style={{ fontSize: 40, marginBottom: 12 }}>✅</div>
            <div style={{ fontSize: 18, fontWeight: 700, color: C.text, marginBottom: 8 }}>Password updated</div>
            <div style={{ fontSize: 14, color: C.textSub, marginBottom: 24 }}>Your password has been reset. You can now sign in with your new password.</div>
            <Btn onClick={() => navigate('/login')} fullWidth>Go to sign in</Btn>
          </div>
        ) : (
          <>
            {(!token || !email) ? (
              <div style={{ textAlign: 'center' }}>
                <div style={{ fontSize: 14, color: '#c62828' }}>Invalid or expired reset link. Please request a new one.</div>
                <button onClick={() => navigate('/login')} style={{ marginTop: 16, background: 'none', border: 'none', color: 'var(--color-button, #1D9E75)', cursor: 'pointer', fontSize: 14 }}>Back to sign in</button>
              </div>
            ) : (
              <>
                <div style={{ textAlign: 'center', marginBottom: 20 }}>
                  <div style={{ fontSize: 18, fontWeight: 700, color: C.text }}>Choose a new password</div>
                  <div style={{ fontSize: 13, color: C.textSub, marginTop: 6 }}>Resetting for <strong>{email}</strong></div>
                </div>
                <Alert message={error} />
                <form onSubmit={handleSubmit}>
                  <Input label="New password" value={newPassword} onChange={setNewPassword} type="password" placeholder="At least 8 characters" required />
                  <Input label="Confirm password" value={confirm} onChange={setConfirm} type="password" placeholder="Re-enter new password" required />
                  <Btn type="submit" disabled={loading} fullWidth size="lg">{loading ? 'Updating…' : 'Update password'}</Btn>
                </form>
              </>
            )}
          </>
        )}
      </div>
    </div>
  );
}
